/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Voice_HindiInputs */

const en_onboarding_voice_hindi = /** @type {(inputs: Onboarding_Voice_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi`)
};

const es_onboarding_voice_hindi = /** @type {(inputs: Onboarding_Voice_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi`)
};

/**
* | output |
* | --- |
* | "Hindi" |
*
* @param {Onboarding_Voice_HindiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_voice_hindi = /** @type {((inputs?: Onboarding_Voice_HindiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Voice_HindiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_voice_hindi(inputs)
	return en_onboarding_voice_hindi(inputs)
});